import { createStore } from 'zustand/vanilla';
import { devtools } from 'zustand/middleware';
import wishlistCrcCodes from '@nike/ux-tread-crc-code/lib/buy/list_items/v1/crcCodes';

const createErrorModalStore = () => {
  return createStore(
    devtools(
      set => ({
        error: null,
        setError: error => {
          error.crcCode = wishlistCrcCodes[error?.code];
          set({ error });
        },
        clearError: () => set({ error: null }),
      }),
      { name: 'NikeShop - ErrorModal' },
    ),
    { enabled: process.env.NODE_ENV === 'development' },
  );
};

export default createErrorModalStore;
